/**
This tooltip module is designed to work only .lendingtree.com domain. For other domain, please disable the same.
*/
<template>
    <div>
        <a
            ref="btnUrl"
            class="btn btn-blue view-site-btn"
            @click="viewSiteClicked(); handleClick(); partnerClicked('btnUrl')">{{ CtaText }}</a>

        <a
            ref="logoUrl"
            class="logo"
            @click="viewSiteClicked(); handleClick(); partnerClicked('logoUrl')"><img :src="logoUrl" /></a>

        <modal
            v-if="ShowModal"
            class="thank-you-modal"
            @close="ShowModal = false;">
            <div slot="body">
                <div class="thanks-block ver-mid">
                    <div class="col-sm-8">
                        <h3>Thank you for your interest in</h3> <h2><b>{{ lenderName }}</b></h2>
                    </div>
                    <div class="col-sm-4">
                        <!-- <img src="https://lt-preprime.s3.amazonaws.com/images/freedom_debt_relief_logo.jpg"> -->
                        <a
                            ref="nameUrl"
                            @click="partnerClicked('nameUrl')">
                            <img :src="logoUrl" />
                        </a>
                    </div>
                </div>
                <div class="row ver-mid">
                    <div class="col-sm-8">
                        <h2>Get Your <b>Free Credit Score</b> and let’s start managing your credit</h2>
                        <ul class="credit-points">
                            <li>100% FREE. No credit card required</li>
                            <li>Free monthly updates</li>
                            <li>Does not affect your credit</li>
                        </ul>
                        <div class="clear-fix"></div>
                        <a
                            :href="MyltUrl"
                            class="btn btn-orange">Get Your Free Credit Score</a>
                    </div>
                    <div class="col-sm-4 text-center hidden-xs">
                        <img src="../../assets/images/credit-score-fair.png" />
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import Modal from './modal.vue';
    import URLs from '~/constants/urls';
    import TrackDataHelper from '~/helpers/track-data-helper';
    import AnalyticsTrack from '~/mixin/analytics-track';
    import AnalyticsHelper from '~/helpers/analytics';
    import SessionIdHelper from '~/helpers/uuid-service';
    import { postPrePrimeRefferal, getMtaId, getCSLeadTrackingId } from '~/services/preprime-api';
    import appStorage from '~/helpers/app-storage';

    export default {
        components: {
            Modal,
        },
        mixins: [AnalyticsTrack],
        props: {
            showPopup: {
                default: false,
            },
            lenderName: {
                default: '',
            },
            lenderLendingEntityId: {
                type: Number,
                default: 0,
            },
            logoUrl: {
                default: '',
            },
            destinationUrl: {
                default: '',
            },
            loanAmount: {
                default: '',
            },
            state: {
                default: '',
            },
            partnerType: {
                default: '',
            },
            leadGuid: {
                default: '',
            },
            ctaText: {
                default: 'Visit Site',
            },
            variationName: {
                default: '',
            },
            placement: {
                default: '',
            },
        },
        data() {
            return {
                ShowModal: this.showPopup,
                MyltUrl: URLs.MYLT_URL,
                SessionId: '',
                newtargetUrl: '',
                CtaText: this.ctaText != null ? this.ctaText : 'Visit Site',
            };
        },
        methods: {
            viewSiteClicked() {
                const sid = SessionIdHelper.getPerprimeSid(this.destinationUrl);
                this.SessionId = sid || SessionIdHelper.getSession();
                TrackDataHelper.setMany(this.trackLenderViewSiteDebtRelief(), 'partnerResults');
                AnalyticsHelper.track('Checkout Started', TrackDataHelper.get('partnerResults'));
            },
            handleClick() {
                const tokenValues = {
                    sid: this.SessionId,
                    amount: this.GetLoanAmount(),
                    state: this.state,
                    mtaid: getMtaId(),
                    qFormId: this.leadGuid,
                };
                this.newtargetUrl = SessionIdHelper.tokenReplacement(SessionIdHelper.getTokenList(this.destinationUrl, tokenValues), this.destinationUrl);
                /* Commented the below code which opens thank you popup */
                // this.ShowModal = true;
                TrackDataHelper.setMany(this.trackVisitLenderDebtRelief(), 'parnerClickedInfo');
                AnalyticsHelper.track('Preprime Partner Clicked', TrackDataHelper.get('parnerClickedInfo'));
            },
            partnerClicked() {
                const tokenValues = {
                    sid: this.SessionId,
                    amount: this.GetLoanAmount(),
                    state: this.state,
                    mtaid: getMtaId(),
                    qFormId: this.leadGuid,
                };
                const url = SessionIdHelper.tokenReplacement(SessionIdHelper.getTokenList(this.destinationUrl, tokenValues), this.destinationUrl);
                const data = {
                    lendingEntityId: this.lenderLendingEntityId,
                    formId: this.leadGuid,
                    sid: this.SessionId,
                    variationName: this.variationName,
                    placement: this.placement,
                    destinationUrl: url,
                    partnername: this.lenderName,
                    partnerlogo: this.logoUrl,
                    partnerurl: url,
                };
                // SUB:4223: Add csleadId in destinationUrl
                if (this.leadGuid) {
                    const storageKey = 'debt-relief-formId';
                    const dataFromStore = appStorage.get(storageKey);
                    if (dataFromStore && dataFromStore.qFormId === this.leadGuid && dataFromStore.csLeadId) {
                        this.SuccessCallback(data, dataFromStore.csLeadId);
                    } else {
                        getCSLeadTrackingId((result) => {
                            if (!isNaN(result)) {
                                const expiration = 60 * 60 * 1000;
                                appStorage.set(storageKey, { qFormId: this.leadGuid, csLeadId: result }, expiration);
                                this.SuccessCallback(data, result);
                            } else {
                                postPrePrimeRefferal(data, 'referral');
                            }
                        }, { formId: this.leadGuid });
                    }
                } else {
                    postPrePrimeRefferal(data, 'referral');
                }
            },
            SuccessCallback(postData, result) {
                if (result) {
                    postData.partnerurl = SessionIdHelper.matchToken('{CSLeadID}', result, postData.partnerurl);
                    postData.destinationUrl = postData.partnerurl;
                }
                postPrePrimeRefferal(postData, 'referral');
            },
            GetLoanAmount() {
                const defaultNullAmount = 11005;
                const defaultZeroAmount = 10005;
                let defaultAmount = 15000;
                if (this.loanAmount === 0 || this.loanAmount === '0') {
                    defaultAmount = defaultZeroAmount;
                } else if (this.loanAmount === null || this.loanAmount === 'null' || this.loanAmount === '' || this.loanAmount === undefined) {
                    defaultAmount = defaultNullAmount;
                } else if (parseInt(this.loanAmount, 10) > 0) {
                    defaultAmount = this.loanAmount;
                }
                return defaultAmount;
            },
        },
    };
</script>
<style lang="scss" src="../../assets/styles/thank-you-popup.scss"></style>
